import {
  loadTeam,
  loadChannels,
  updateBlacklist,
  addToBlacklist,
  removeFromBlacklist,
} from '../services/api/slack';
import actionTypes from './action_types';

export function loadSlackTeam() {
  return (dispatch, getState) => {
    const currentUser = getState().auth.user;
    return loadTeam(currentUser.id).then(({ team }) => (
      dispatch({
        type: actionTypes.SLACK_TEAM_LOADED,
        payload: { team },
      })
    ));
  };
}

export function loadSlackChannels() {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;
    const teamId = getState().slack.team.teamId;

    return loadChannels(userId, teamId)
      .then(channels => (
        dispatch({
          type: actionTypes.SLACK_CHANNELS_LOADED,
          payload: { channels },
        })
      ));
  };
}

export function loadSlackUserData() {
  return (dispatch, getState) => {
    return dispatch(loadSlackTeam())
      .then(() => {
        if (getState().slack.team) {
          dispatch(loadSlackChannels());
        }
      });
  };
}

export function updateSlackBlacklist({ removeIds = [], addIds = [] }) {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;
    const teamId = getState().slack.team.teamId;

    return updateBlacklist({ userId, teamId, removeIds, addIds })
      .then(channels => (
        dispatch({
          type: actionTypes.SLACK_CHANNELS_UPDATED,
          payload: { channels },
        })
      ));
  };
}

export function addToSlackBlacklist(channelId) {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;
    const teamId = getState().slack.team.teamId;

    return addToBlacklist({ userId, teamId, channelId })
      .then(() => (
        dispatch({
          type: actionTypes.SLACK_CHANNEL_ADDED_TO_BLACKLIST,
          payload: { channelId },
        })
      ));
  };
}

export function removeFromSlackBlacklist(channelId) {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;
    const teamId = getState().slack.team.teamId;

    return removeFromBlacklist({ userId, teamId, channelId })
      .then(() => (
        dispatch({
          type: actionTypes.SLACK_CHANNEL_REMOVED_FROM_BLACKLIST,
          payload: { channelId },
        })
      ));
  };
}




// WEBPACK FOOTER //
// ./src/actions/slack.js